<template>
  <div>
    <header id='custom-header'>
      <ul>
        <li v-if="headerBack" @click="backBtn">
          <a class="backBtn">
            <span class='ico icoBack'></span>
          </a>
        </li>
        <li class="custom-header-center">{{ headerText }}</li>
        <li class="custom-header-right close" @click.stop.prevent="closeBtn" v-if="headerBtn">
          닫기
        </li>
      </ul>
    </header>
  </div>
</template>
<script>
export default {
  props: {
    headerText: String,
    headerBtn: Boolean,
    headerBack: Boolean,
    termsToggle: Boolean
  },
  mounted () {
    window.backBtn = () => {
      if (this.termsToggle) { // 약관이 열려있다면
        this.$emit('termsToggleChange')
      } else {
        this.closeBtn()
      }
    }
  },
  methods: {
    backBtn () {
      this.$emit('reSameInputChange')
    },
    closeBtn () {
      if (localStorage.getItem('joinFlag')) { // bottomMenu, allMenuPopup에서 접근하였을때
        this.appMoveMain()
      } else {
        this.closeComponentEmit()
      }
    }
  }
}
</script>
